import C from './loadable';
import './style.css';

export default C;
